
// TODO Es fehltn Schwedisch... und irgendwas da unten ist nicht vollständig.

export default function(hyperform) {
    if (window.language === 'de') {
        hyperform.addTranslation("de", {
            TextTooLong: "Bitte kürzen Sie diesen Text auf maximal %l Zeichen (Sie verwenden derzeit %l Zeichen).",
            TextTooShort: "Bitte verwenden Sie zumindest %l Zeichen (Sie verwenden derzeit %l Zeichen).",
            ValueMissing: "Bitte füllen Sie dieses Feld aus.",
            CheckboxMissing: "Bitte klicken Sie dieses Kästchen an, wenn Sie fortsetzen wollen.",
            RadioMissing: "Bitte wählen Sie eine dieser Optionen.",
            FileMissing: "Bitte wählen Sie eine Datei.",
            SelectMissing: "Bitte wählen Sie einen Eintrag in der Liste.",
            InvalidEmail: "Bitte geben Sie eine E-Mail-Adresse ein.",
            InvalidURL: "Bitte geben Sie eine Internetadresse ein.",
            InvalidDate:"Bitte geben Sie ein gültiges Datum ein.",
            PatternMismatch: "Bitte halten Sie sich an das vorgegebene Format.",
            PatternMismatchWithTitle: "Bitte halten Sie sich an das vorgegebene Format: %l.",
            NumberRangeOverflow: "Bitte wählen Sie einen Wert, der nicht größer ist als %l.",
            DateRangeOverflow: "Bitte wählen Sie einen Wert, der nicht später ist als %l.",
            TimeRangeOverflow: "Bitte wählen Sie einen Wert, der nicht später ist als %l.",
            NumberRangeUnderflow: "Bitte wählen Sie einen Wert, der nicht kleiner ist als %l.",
            DateRangeUnderflow: "Bitte wählen Sie einen Wert, der nicht früher ist als %l.",
            TimeRangeUnderflow: "Bitte wählen Sie einen Wert, der nicht früher ist als %l.",
            StepMismatch: "Bitte wählen Sie einen gültigen Wert. Die zwei nähesten gültigen Werte sind %l und %l.",
            StepMismatchOneValue: "Bitte wählen Sie einen gültigen Wert. Der näheste gültige Wert ist %l.",
            BadInputNumber: "Bitte geben Sie eine Nummer ein.",
            "Please match the requested type.": "Bitte passen Sie die Eingabe dem geforderten Typ an.",
            "Please comply with all requirements.": "Bitte erfüllen Sie alle Anforderungen.",
            "Please lengthen this text to %l characters or more (you are currently using %l characters).": "Bitte verlängern Sie diesen Text auf mindestens %l Zeichen (Sie verwenden derzeit %l Zeichen).",
            "Please use the appropriate format.": "Bitte verwenden Sie das passende Format.",
            "Please enter a comma separated list of email addresses.": "Bitte geben Sie eine komma-getrennte Liste von E-Mail-Adressen an.",
            "Please select a file of the correct type.": "Bitte wählen Sie eine Datei vom korrekten Typ.",
            "Please select one or more files.": "Bitte wählen Sie eine oder mehrere Dateien.",
            "any value": "jeder Wert",
            "any valid value": "jeder gültige Wert",
        });
        hyperform.setLanguage("de");
    }
    if (window.language === 'fr') {
        hyperform.addTranslation("fr", {
            TextTooLong: "Veuillez raccourcir ce champ à %l caractères ou moins (vous utilisez actuellement %l caractères).",
            TextTooShort: "Veuillez utiliser au moins %l caractères pour ce champ (vous utilisez actuellement %l caractères).",
            ValueMissing: "Veuillez compléter ce champ.",
            CheckboxMissing: "Veuillez cocher cette case si vous désirez poursuivre.",
            RadioMissing: "Veuillez sélectionner l’une de ces options.",
            FileMissing: "Veuillez sélectionner un fichier.",
            SelectMissing: "Veuillez sélectionner un élément de la liste.",
            InvalidEmail: "Veuillez saisir une adresse électronique valide.",
            InvalidURL: "Veuillez saisir une URL.",
            //InvalidDate:"",
            PatternMismatch: "Veuillez modifier la valeur pour correspondre au format demandé.",
            PatternMismatchWithTitle: "Veuillez modifier la valeur du champ pour correspondre au format demandé : %l.",
            NumberRangeOverflow: "Veuillez sélectionner une valeur inférieure ou égale à %l.",
            DateRangeOverflow: "Veuillez sélectionner une valeur antérieure ou égale à %l.",
            TimeRangeOverflow: "Veuillez sélectionner une valeur antérieure ou égale à %l.",
            NumberRangeUnderflow: "Veuillez sélectionner une valeur supérieure ou égale à %l.",
            DateRangeUnderflow: "Veuillez sélectionner une valeur postérieure ou égale à %l.",
            TimeRangeUnderflow: "Veuillez sélectionner une valeur postérieure ou égale à %l.",
            StepMismatch: "Veuillez sélectionner une valeur valide. Les deux valeurs valides les plus proches sont %l et %l.",
            StepMismatchOneValue: "Veuillez sélectionner une valeur valide. La valeur valide la plus proche est %l.",
            BadInputNumber: "Veuillez saisir un nombre.",
            "Please match the requested type.": "Veuillez respecter le type de champ demandé.",
            "Please comply with all requirements.": "Veuillez respecter toutes les conditions.",
            "Please lengthen this text to %l characters or more (you are currently using %l characters).": "Veuillez allonger ce texte pour atteindre %l caractères ou plus (vous avez écrit pour l'instant %l caractères).",
            "Please use the appropriate format.": "Veuillez utiliser le format approprié.",
            "Please enter a comma separated list of email addresses.": "Veuillez saisir une liste d'adresses électroniques séparées par des virgules.",
            "Please select a file of the correct type.": "Veuillez sélectionner un fichier du type approprié.",
            "Please select one or more files.": "Veuillez sélectionner un ou plusieurs fichiers.",
            "any value": "n'importe quelle valeur",
            "any valid value": "n'importe quelle valeur valide",
        });
        hyperform.setLanguage("fr");
    }
    if (window.language === 'it') {
        hyperform.addTranslation("it", {
            TextTooLong: "Ridurre la lunghezza del testo a %l caratteri o meno (attualmente si stanno utilizzando %l caratteri)",
            TextTooShort: "Utilizzare almeno %l caratteri (attualmente si stanno utilizzando %l caratteri)",
            ValueMissing: "Compilare questo campo",
            CheckboxMissing: "Selezionare questa casella per procedere",
            RadioMissing: "Selezionare una delle opzioni disponibili",
            FileMissing: "Selezionare un file",
            SelectMissing: "Selezionare un elemento dall’elenco",
            InvalidEmail: "Inserire un indirizzo email",
            InvalidURL: "Inserire un URL",
            //InvalidDate:"",
            PatternMismatch: "Inserire un valore nel formato richiesto",
            PatternMismatchWithTitle: "Inserire un valore nel formato richiesto: %l",
            NumberRangeOverflow: "Selezionare un valore inferiore o uguale a %l.",
            DateRangeOverflow: "Selezionare un valore precedente o uguale a %l.",
            TimeRangeOverflow: "Selezionare un valore precedente o uguale a %l.",
            NumberRangeUnderflow: "Selezionare un valore superiore o uguale a %l.",
            DateRangeUnderflow: "Selezionare un valore successivo o uguale a %l.",
            TimeRangeUnderflow: "Selezionare un valore successivo o uguale a %l.",
            StepMismatch: "Selezionare un valore valido. I due valori validi più vicini sono %l e %l",
            StepMismatchOneValue: "Selezionare un valore valido. Il valore valido più vicino è %l",
            BadInputNumber: "Inserire un numero",
            //"Please match the requested type.": "",
            //"Please comply with all requirements.": "",
            //"Please lengthen this text to %l characters or more (you are currently using %l characters).": "",
            //"Please use the appropriate format.": "",
            //"Please enter a comma separated list of email addresses.": "",
            //"Please select a file of the correct type.": "",
            //"Please select one or more files.": "",
            //"any value":"",
            //"any valid value":"",
        });
        hyperform.setLanguage("it");
    }
    if (window.language === 'nl') {
        hyperform.addTranslation('nl', {
            TextTooLong: "Kort deze tekst in tot %l tekens of minder (u gebruikt nu %l tekens).",
            TextTooShort: "Gebruik minstens %l tekens (u gebruikt momenteel %l tekens).",
            ValueMissing: "Vul dit veld in.",
            CheckboxMissing: "Vink dit vakje aan als u wilt doorgaan.",
            RadioMissing: "Selecteer een van deze opties.",
            FileMissing: "Selecteer een bestand.",
            SelectMissing: "Selecteer een item in de lijst.",
            InvalidEmail: "Voer een e-mailadres in.",
            InvalidURL: "Voer een URL in.",
            InvalidDate: "Voer een geldige datum in.",
            PatternMismatch: "Gebruik de gevraagde indeling.",
            PatternMismatchWithTitle: "Gebruik de gevraagde indeling: %l.",
            NumberRangeOverflow: "Selecteer een waarde die niet hoger is dan %l.",
            DateTimeRangeOverflow: "Selecteer een waarde die niet later is dan %l.",
            NumberRangeUnderflow: "Selecteer een waarde die niet lager is dan %l.",
            DateTimeRangeUnderflow: "Selecteer een waarde die niet vroeger is dan %l.",
            StepMismatch: "Selecteer een geldige waarde. De twee dichtstbijzijnde geldige waarden zijn %l en %l.",
            StepMismatchOneValue: "Selecteer een geldige waarde. De dichtstbijzijnde geldige waarde is %l.",
            BadInputNumber: "Voer een getal in.",
            "Please match the requested type.": "Pas de invoer aan aan het vereiste type.",
            "Please comply with all requirements.": "Voldoe aan alle vereisten.",
            "Please lengthen this text to %l characters or more (you are currently using %l characters).": "Verleng deze tekst tot ten minste %l tekens (u gebruikt momenteel %l tekens).",
            "Please use the appropriate format.": "Gebruik de juiste indeling.",
            "Please enter a comma separated list of email addresses.": "Voer een door komma's gescheiden lijst van e-mailadressen in.",
            "Please select a file of the correct type.": "Selecteer een bestand van het juiste type.",
            "Please select one or more files.": "Selecteer een of meer bestanden.",
            "any value": "elke waarde",
            "any valid value": "elke geldige waarde",
        });
        hyperform.setLanguage("nl");
    }
    if (window.language === 'ru') {
        hyperform.addTranslation("ru", {
            TextTooLong: "Пожалуйста, сократите этот текст до %l символов или меньше (сейчас Вы используете %l символов).",
            TextTooShort: "Пожалуйста, используйте не менее %l символов (сейчас Вы используете %l символов).",
            ValueMissing: "Пожалуйста, заполните это поле.",
            CheckboxMissing: "Пожалуйста, поставьте флажок, если Вы хотите продолжить.",
            RadioMissing: "Пожалуйста, выберите один из этих вариантов.",
            FileMissing: "Пожалуйста, выберите файл.",
            SelectMissing: "Пожалуйста, выберите пункт из списка.",
            InvalidEmail: "Пожалуйста, введите адрес электронной почты.",
            InvalidURL: "Пожалуйста, введите веб-адрес.",
            InvalidDate: "Пожалуйста, введите дату",
            PatternMismatch: "Пожалуйста, придерживайтесь установленного формата.",
            PatternMismatchWithTitle: "Пожалуйста, придерживайтесь установленного формата: %l.",
            NumberRangeOverflow: "Пожалуйста, выберите значение, не больше чем %l.",
            DateRangeOverflow: "Пожалуйста, выберите значение, не позднее %l.",
            TimeRangeOverflow: "Пожалуйста, выберите значение, не позднее %l.",
            NumberRangeUnderflow: "Пожалуйста, выберите значение, не менее %l.",
            DateRangeUnderflow: "Пожалуйста, выберите значение, не ранее, чем %l.",
            TimeRangeUnderflow: "Пожалуйста, выберите значение, не ранее, чем %l.",
            StepMismatch: "Пожалуйста, выберите корректное значение. Два ближайших допустимых значения %l и %l",
            StepMismatchOneValue: "Пожалуйста, введите корректное значение. Ближайшее допустимое значение %l.",
            BadInputNumber: "Пожалуйста, введите число",
            "Please match the requested type.": "Пожалуйста, придерживайтесь требуемого типа.",
            "Please comply with all requirements.": "Пожалуйста, выполните все необходимые условия.",
            "Please lengthen this text to %l characters or more (you are currently using %l characters).": "Пожалуйста, увеличьте этот текст на %l символов или более (вы используете %l символов).",
            "Please use the appropriate format.": "Пожалуйста, используйте правильный формат.",
            "Please enter a comma separated list of email addresses.": "Пожалуйста, введите список адресов электронной почты через запятую",
            "Please select a file of the correct type.": "Пожалуйста, выберите файл правильного типа.",
            "Please select one or more files.": "Пожалуйста, выберите один или несколько файлов.",
            "any value": "любое значение",
            "any valid value": "любое допустимое значение",
        });
        hyperform.setLanguage("ru");
    }
    if (window.language === 'zh') {
        hyperform.addTranslation("zh", {
            TextTooLong: "请将此文本缩短至 %l 个字符或更少（您现在已经输入了 %l 个字符）。",
            TextTooShort: "请使用至少 %l 个字符（您目前使用 %l 个字符）。",
            ValueMissing: "请填写此字段。",
            CheckboxMissing: "若要继续，请检选此检查框。",
            RadioMissing: "请选择一个选项。",
            FileMissing: "请选择一个文件。",
            SelectMissing: "请选择列表中的一项。",
            InvalidEmail: "请输入电子邮件地址。",
            InvalidURL: "请输入一个 URL。",
            //InvalidDate:"",
            PatternMismatch: "请匹配要求的格式。",
            PatternMismatchWithTitle: "请匹配要求的格式： %l。",
            NumberRangeOverflow: "请选择一个不大于 %l 的值。",
            DateRangeOverflow: "请选择一个不晚于 %l 的值。",
            TimeRangeOverflow: "请选择一个不晚于 %l 的值。",
            NumberRangeUnderflow: "请选择一个不小于 %l 的值。",
            DateRangeUnderflow: "请选择一个不早于 %l 的值。",
            TimeRangeUnderflow: "请选择一个不早于 %l 的值。",
            StepMismatch: "请选择一个有效的值，值要在 %l 和 %l 的范围内。",
            StepMismatchOneValue: "请选择一个有效的值。最接近的有效值是 %l。",
            BadInputNumber: "请输入一组数字。",
            //"Please match the requested type.": "",
            //"Please comply with all requirements.": "",
            //"Please lengthen this text to %l characters or more (you are currently using %l characters).": "",
            //"Please use the appropriate format.": "",
            //"Please enter a comma separated list of email addresses.": "",
            //"Please select a file of the correct type.": "",
            //"Please select one or more files.": "",
            //"any value":"",
            //"any valid value":"",
        });
        hyperform.setLanguage("zh");
    }
    if (window.language === 'cs') {
        hyperform.addTranslation("cs", {
            TextTooLong: "Zkraťte prosím text na %l znaků nebo méně (aktuální velikost textu je %l znaků).",
            TextTooShort: "Použijte prosím text alespoň %l znaků dlouhý (aktuální velikost textu je %l znaků).",
            ValueMissing: "Vyplňte prosím toto pole.",
            CheckboxMissing: "Zaškrtněte prosím toto zaškrtávací pole.",
            RadioMissing: "Zvolte prosím některou možnost.",
            FileMissing: "Vyberte prosím soubor.",
            SelectMissing: "Zvolte prosím některou položku v seznamu.",
            InvalidEmail: "Vložte prosím platnou e-mailovou adresu.",
            InvalidURL: "Vložte prosím platnou URL.",
            //InvalidDate:"",
            PatternMismatch: "Vyplňte prosím pole v požadovaném formátu.",
            PatternMismatchWithTitle: "Vyplňte prosím pole v požadovaném formátu: %l.",
            NumberRangeOverflow: "Zvolte prosím číslo, která není větší než %l.",
            DateRangeOverflow: "Zvolte prosím datum, které není pozdější než %l.",
            TimeRangeOverflow: "Zvolte prosím čas, který není pozdější než %l.",
            NumberRangeUnderflow: "Zvolte prosím číslo, které není menší než %l.",
            DateRangeUnderflow: "Zvolte prosím datum, které není dřívější než %l.",
            TimeRangeUnderflow: "Zvolte prosím čas, který není dřívější než %l.",
            StepMismatch: "Zvolte prosím platnou hodnotu. Nejbližší platné hodnoty jsou %l a %l.",
            StepMismatchOneValue: "Zvolte prosím platnou hodnotu. Nejbližší platná hodnota je %l.",
            BadInputNumber: "Vložte prosím platné číslo.",
            "Please match the requested type.": "Vyplňte prosím všechna požadovaná pole.",
            "Please comply with all requirements.": "Při vyplňování je nutné dodržet všechny požadavky.",
            "Please lengthen this text to %l characters or more (you are currently using %l characters).": "Zvětšete prosím tento text na %l znaků nebo více (váš text má momentálně %l znaků).",
            "Please use the appropriate format.": "Použijte prosím správný formát.",
            "Please enter a comma separated list of email addresses.": "Zadejte prosím seznam e-mailových adres oddělených čárkou.",
            "Please select a file of the correct type.": "Zvolte prosím správný typ souboru.",
            "Please select one or more files.": "Zvolte prosím jeden nebo více souborů.",
            //"any value":"",
            //"any valid value":"",
        });
        hyperform.setLanguage("cs");
    }
}
